import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { Notification } from '../../interfaces/notification.model';

@Component({
  selector: 'notification',
  templateUrl: 'notification.html'
})
export class NotificationComponent {

  notification: Notification;
  read: boolean;
  moreThanOne: boolean;

  constructor(public viewCtrl: ViewController, params: NavParams) {
    this.notification = params.get('notification');
    this.moreThanOne = params.get('moreThanOne');
  }

  dismiss() {
    let data = {
      skipAll: false,
      read: this.read
    };
    this.viewCtrl.dismiss(data); 
  }

  skipAll(){
    let data = {
      skipAll: true,
      read: false
    };
    this.viewCtrl.dismiss(data); 
  }

}



// WEBPACK FOOTER //
// ./src/components/notification/notification.ts